/* eslint-disable max-len */
// This file is auto generated by before-build.js and will be overwritten with each "ionic cap sync/copy"
export const AppVersion = JSON.parse("{\"flavor\":\"PRD\",\"gitHash\":\"f6300f22b67ba1e017a20bc856ff942d48e4e8f1\",\"appVersion\":\"0.0.1\",\"buildTimestamp\":1758276367611}")
